import { useEffect, useMemo, useRef } from 'react';
import debounce from 'lodash/debounce';

// When lodash's debounce is used directly in a component, it causes the debounced function to
// be re-created on every render, which can cause the function to be called multiple times.
// This hook memoizes a debounced wrapper function that is only created once, which then calls the
// actual callback through a ref which can be updated without re-debouncing the callback on render.
export default (callback, delay = 1000) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  return useMemo(() => {
    const func = (args = null) => {
      ref.current?.(args);
    };

    return debounce(func, delay);
  }, [delay]);
};
